import { ElementType, PropsWithChildren } from "react"

import { cn } from "@/utilities/etc"

type TextLevel = 1 | 2 | 3 | "disclaimer"

type PageTitleProps = { level?: TextLevel } & (
  | ({
      as?: "p"
    } & React.HTMLAttributes<HTMLParagraphElement>)
  | ({
      as: "span"
    } & React.HTMLAttributes<HTMLSpanElement>)
)

const Text: React.FC<PropsWithChildren<PageTitleProps>> = (props) => {
  const level = props.level || 1
  const Tag = (props.as || "p") as ElementType
  return (
    <Tag {...props} className={cn(props.className, `body--${level}`)}>
      {props.children}
    </Tag>
  )
}

export default Text
